export default __webpack_public_path__ + "static/media/hht1_direction_word_play_01.24c3ceb2.jpg";